import { ArgsType, Field } from '@nestjs/graphql'
import { BaseGetByIdArgs } from '../base/baseGetById.args'

@ArgsType()
export class ArcGetByIdArgs extends BaseGetByIdArgs<ArcGetByIdArgs> {
  @Field(t => Boolean, { nullable: true })
  allowOwnClaim?: boolean

  @Field(t => Boolean, { nullable: true})
  skipEligibleCheck?: boolean
}
